<template>
    <HeaderComponent/>
    <main class="flex-grow container mx-auto px-4 py-8 md:py-12 lg:py-16">
      <div class="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
        <div class="w-full lg:w-1/2 bg-white rounded-lg shadow-lg p-6">
          <h2 class="text-2xl font-bold text-indigo-800 mb-6">Contact Us</h2>
            <client-only>
                <ContactForm
                :formId="4"
                :storedData="storedCtaData"
                />
            </client-only>
        </div>
        <div class="w-full lg:w-1/2 bg-gray-50 rounded-lg p-6 mt-8 lg:mt-0">
          <h2 class="text-2xl md:text-3xl font-bold text-indigo-800 mb-6 uppercase">
            {{ storedCtaData?.form_heading || "LET'S KEEP IN TOUCH" }}
          </h2>
          <p class="mb-6 text-gray-700 leading-relaxed">
            Salesforce Implementation | Salesforce Setup & Configuration | Custom Development | Salesforce
            Integration | Salesforce support | Maintenance | Wordpress Portal using Salesforce Data
          </p>
  
  
          <div class="space-y-4">
            <div class="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-600 mr-3 flex-shrink-0" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              <a href="mailto:support@arrify.com" class="text-blue-600 hover:underline break-all">support@arrify.com</a>
            </div>
            <div class="flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-600 mr-3 mt-1 flex-shrink-0" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              <p class="text-gray-700">
                S5, 1st Floor, IT Park Rd, Sitapura Industrial Area, Sitapura, Jaipur, Rajasthan 302022
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <FooterComponent/>
  </template>
  
  <script setup>
  import {ref, onMounted} from 'vue';
  import {useCommonHead} from '../composables/useCommonHead';
  import HeaderComponent from "../components/Header.vue";
  import FooterComponent from "../components/Footer.vue";
  import ContactForm from "../components/ContactForm.vue";
  
  const pageTitle = 'Contact Us - Arrify';
  const pageDescription = 'Get in touch with Arrify for Salesforce Development, WordPress solutions, and other IT services. We\'re here to help grow your business.';
  const currentUrl = 'https://arrify.com/contact/';
  
  const storedCtaData = ref(null);
  
  onMounted(() => {
    // Retrieve stored CTA data
    const storedData = localStorage.getItem('ctaData');
    if (storedData) {
      storedCtaData.value = JSON.parse(storedData);
      // Clear the stored data after retrieving it
      localStorage.removeItem('ctaData');
    }
  });
  
  useCommonHead(pageTitle, pageDescription, currentUrl);
  </script>
  
  <style scoped>
  /* Contact Page styles */
  </style>